import RoutesAPI from '../routes/api.routes';
import handlerError from '../routes/error-handler';
import axiosInstance from '../routes/axios-instance';

export const UserModel = {
  email: '',
  password: '',
};

export default {
  namespaced: true,
  state: {
    user: { ...UserModel },
    token: localStorage.getItem('auth_token') || null,
    refreshToken: localStorage.getItem('refresh_token') || null,
  },
  mutations: {
    login(state, response) {
      state.token = response.token;
      state.refreshToken = response.refreshToken;
    },
    logout(state) {
      state.token = null;
      state.refreshToken = null;
    },
  },
  actions: {
    login({ commit }, body) {
      return new Promise((resolve, reject) => {
        axiosInstance.post(RoutesAPI.LOGIN, body)
          .then((response) => {
            if (response.data.error) {
              reject(handlerError(response.data.error));
            }

            const { token, refreshToken } = response.data;
            localStorage.setItem('auth_token', token);
            localStorage.setItem('refresh_token', refreshToken);

            // set the authorization header after login for axios
            axiosInstance.defaults.headers.Authorization = `Bearer ${token}`;

            commit('login', response.data);

            resolve(response);
          })
          .catch((e) => {
            localStorage.removeItem('auth_token');
            localStorage.removeItem('refresh_token');
            commit('logout');
            reject(e);
            return handlerError(e);
          });
      });
    },

    logout({ commit }) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('refresh_token');
      commit('logout');
    },

    refreshToken({ commit }) {
      return new Promise((resolve, reject) => {
        axiosInstance.post(RoutesAPI.REFRESH_TOKEN, {
          refreshToken: localStorage.getItem('refresh_token'),
        })
          .then((response) => {
            if (response.data.error) {
              localStorage.removeItem('auth_token');
              localStorage.removeItem('refresh_token');
              reject(response.data.error);
            } else {
              const { token, refreshToken } = response.data;
              localStorage.setItem('auth_token', token);
              localStorage.setItem('refresh_token', refreshToken);

              commit('login', response.data);
            }
            resolve(response);
          })
          .catch((e) => {
            localStorage.removeItem('auth_token');
            localStorage.removeItem('refresh_token');
            commit('logout');
            reject(e);
            return handlerError(e);
          });
      });
    },
  },
  getters: {
    isLoggedIn(state) {
      return state.token !== null;
    },
  },
};
